import { CardActionName } from "@/components/Cards/View/Details/Actions/Name"
import { useStoreCardView } from "@usher/pe-client-front-end-lib"
import { FormattedMessage, useIntl } from "react-intl"
import { DetailItem } from "./DetailItem"

export const CardDetailsDetails = () => {
  const { $t } = useIntl()
  const { card_country, status, embossingName, type, card_type, card_brand } = useStoreCardView((state) => state.card)
  let cardType = type === "1" ? "Virtual" : "Physical"
  if (card_type) cardType += ` / ${card_type}`
  return (
    <div className="block-one-card_details">
      <div className="block-one-card_info-title text-[14px]">
        <FormattedMessage id="details" />
      </div>
      <DetailItem label={$t({ id: "card-name" })}>
        <CardActionName />
      </DetailItem>
      {/* <DetailItem label={$t({ id: "account" })} value="USERNAME" /> */}
      <DetailItem label={$t({ id: "status" })}>{status}</DetailItem>
      <DetailItem label={$t({ id: "cardholder" })}>{embossingName || "N/A"}</DetailItem>
      {type !== "3" && <DetailItem label={$t({ id: "card-type" })}>{cardType}</DetailItem>}
      {Boolean(card_brand) && <DetailItem label="Brand">{card_brand}</DetailItem>}
      {Boolean(card_country) && <DetailItem label="Country">{card_country}</DetailItem>}
    </div>
  )
}
